import {Action} from '@ngrx/store';
import {BijbError} from '../../../models/bijb-error';

export class GetChecklistItemsErrorAction implements Action {
  public static readonly type = 'GetChecklistItemsErrorAction';

  constructor(public error: BijbError) {
  }

  public type = GetChecklistItemsErrorAction.type;
}
